import {useMemo} from "react";
import {useSelector} from "react-redux";

export const useBusinessHours = () => {
    const {restaurant} = useSelector((state) => state.dashboard.view);
    const restaurantSettings = restaurant?.value?.settings;

    return useMemo(() => {
        const dayMap = {
            MONDAY: 1,
            TUESDAY: 2,
            WEDNESDAY: 3,
            THURSDAY: 4,
            FRIDAY: 5,
            SATURDAY: 6,
            SUNDAY: 0,
        };

        return Object.entries(restaurantSettings?.operatingHours ?? {}).flatMap(
            ([dayName, {available, startTime, endTime}]) => {
                if (!available || !startTime || !endTime) return [];

                const dayNum = dayMap[dayName];

                if (endTime > startTime) {
                    return {daysOfWeek: [dayNum], startTime, endTime};
                }

                return [
                    {daysOfWeek: [dayNum], startTime, endTime: '24:00:00'},
                    {daysOfWeek: [(dayNum + 1) % 7], startTime: '00:00:00', endTime},
                ];
            }
        );
    }, [restaurantSettings?.operatingHours]);
}